module.exports = __webpack_public_path__ + "img/PR.44606b44.svg";